<template>
  <section class="section section_bg " style="">
    <loading-block v-if="is_notify_load==false" :loading="!is_notify_load"/>


    <div  class="container-fluid mobile_div" v-if="is_notify_load">

      <div class="second_section text-center container mobile_div">

        <router-link tag="a" class="btn" :to="{name: 'setup_link'}"  ><i class="fa fa-backward"></i> Назад</router-link>

      </div>



      <div class="second_section text-center container mobile_div ">

        <h4 class="mt-2 mb-2 text-center"  >Уведомления</h4>
        <div class="">
          <h5><input type="checkbox" v-model="notify.show_only_unread" @change="changeNotifyType"/>
            Показывать только не прочитанные</h5>

        </div>
        <div class="col-12">
          <p><button class="btn" type="button" @click="markerAllNotifyRead">Пометить <br>все прочитанным</button></p>

        </div>
        <ul class="nav mt-4 notifys_ul d-flex justify-content-center ">
          <li class="nav-item">
            <a class="btn" :class="{ 'btn-active':open_tab=='all' }" @click="openType('all')">Все<span class="badge badge-light">{{ notify_counts.total}}</span></a>
          </li>


        </ul>


      </div>

      <div class="second_section container mobile_div">
        <div class=" mt-4">

          <div class="notify_card card col-lg-12 mt-4" v-if="(((notify.show_only_unread==true && notify_object.isread==0) || (notify.show_only_unread==false)) && (notify_object.json.type==open_tab || open_tab=='all'))"
              v-for="(notify_object,notify_index) in notifys" :key="notify_object.last_id">
            <div class="row d-flex justify-content-center">
              <div class="col-sm-3 col-md-3 col-12 d-flex justify-content-center">
                <router-link  tag="a" class="pt-2 pb-2" :to="{name: 'user_page_main', params: { user_id: notify_object.who.last_id }}"> <img :src="image_url+notify_object.who.avatar" style="max-width: 100px" class="img-thumbnail"></router-link>
              </div>
              <div class="col-sm-6 col-md-6 col-12 text-center ">
                <router-link  tag="a" :to="{name: 'user_page_main', params: { user_id: notify_object.who.last_id }}"><h4>{{ notify_object.who.name}}</h4></router-link>
                <p> {{ notify_object.json.title}}</p>
                <div class="mb-2" v-for="(button,button_index) in notify_object.json.buttons" :key="button_index">
                  <a href="javascript:void;" class="btn " @click="clickNotify(button,notify_object,notify_index)">{{ button.title }}</a>&nbsp;&nbsp;
                  &nbsp;
                </div>
              </div>
              <div class="col-sm-3 col-md-3 col-12 d-flex justify-content-center">
                <p class="pt-2 pb-2"><i class="ni ni-calendar-grid-58"></i> {{ notify_object.created_at}}</p>
              </div>
            </div>




          </div>
          <div class="notify_card card col-lg-12 mt-4 section_gray_bg  " v-if="notify_counts.total>notify.offset">
            <div class="row second_section d-flex justify-content-center">
              <button class="btn" @click="loadMoreNotify()">Загрузить еще</button>

            </div>
          </div>

        </div>
      </div>


    </div>
  </section>
</template>

<script>
import Api from "@/models/Api";
import LoadingBlock from "@/components/Custom/LoadingBlock";
import Vue from "vue";
export default {
  name: "Notify",
  data() {
    return {
      "open_tab": "all",
      "image_url":"",


      is_notify_load: false,
      "notify_counts": {
        "total":0,
        "projects": 0,
        "freelance": 0,
        "comments": 0,
        "invoices": 0,
      },
      "notifys": null,
      "notify": {
        "show_only_unread": true,
        'limit':10,
        'offset':0,
      },
      'DISABLE_NOTIFY_TYPES':0,

    }
  },
  mounted: function () {
    var app=this;
    app.is_notify_load = false;
    app.notify_counts.comments = 0;
    app.notify_counts.freelance = 0;
    app.notify_counts.projects = 0;
    app.notify_counts.invoices = 0;
    app.notify_counts.total = 0;
    app.image_url = Vue.config.IMAGE_URL;
    app.DISABLE_NOTIFY_TYPES=Vue.config.DISABLE_NOTIFY_TYPES;


    Api.loadNotify(app.notify, function (data) {



      app.notify_counts.comments = data.total_comments;
      app.notify_counts.freelance = data.total_freelance;
      app.notify_counts.projects = data.total_projects;
      app.notify_counts.invoices = data.total_invoices;
      app.notify_counts.total= data.total;

      app.notifys = data.notifys;
      app.notify.offset=data.offset;
      app.is_notify_load = true;

    });
  },

  methods: {
    openType(type){
      var app=this;
      app.open_tab=type;

      return false;

    },
    clickNotify(button, notify, notify_index) {

      var app = this;
      Api.setReadNotify(notify.last_id, function () {

        if (app.notify.show_only_unread == true) {
          app.loadNotify();
        }
        if (button.type == "load_invoice") {
          app.$router.push({"name": "invoice", "params": {"id": button.params.invoice_id, "rand": Math.random()}});
          // this.$router.push({"name": "project", "params": {"id": button.params.id, "rand": Math.random()}});
          // vm.$forceUpdate();
        }
        if(button.type=="load_reward"){
          app.$router.push({"name": "reward_one", "params": {"id": button.params.id, "rand": Math.random()}});


        }
        if (button.type == "load_project") {
          if(button.params.invoice_id){
            app.$router.push({"name": "project_list_invoices", "params": {"id": button.params.id, "rand": Math.random()}});

          }else {
            app.$router.push({"name": "project", "params": {"id": button.params.id, "rand": Math.random()}});
          }

          // this.$router.push({"name": "project", "params": {"id": button.params.id, "rand": Math.random()}});
          // vm.$forceUpdate();

        }
        if(button.type=="load_post"){
          app.$router.push({"name": "post", "params": {"id": button.params.id, 'alias':button.params.alias,"rand": Math.random()}});
        }
        if(button.type=='load_article'){
          app.$router.push({"name": "one_article", "params": {"id": button.params.project_id, 'post_id':button.params.id}});

        }
        if (button.type == "remove_notify") {
          Api.setRemoveNotify(notify.last_id, function () {
            app.loadNotify();
          });
        }
      });

    },
    changeNotifyType() {
      this.loadNotify();
    },
    markerAllNotifyRead() {
      var app = this;
      Api.setReadAllNotify(function () {


        app.notifys = [];
        app.is_notify_load = false;
        app.notify_counts.total = 0;
        app.notify_counts.comments = 0;
        app.notify_counts.freelance = 0;
        app.notify_counts.projects = 0;
        app.notify_counts.invoices = 0;
        app.loadNotify();
      });
    },
    loadMoreNotify(){
      var app=this;
      Api.loadNotify(app.notify, function (data) {

        app.notify_counts.comments = data.total_comments;
        app.notify_counts.freelance = data.total_freelance;
        app.notify_counts.projects = data.total_projects;
        app.notify_counts.invoices = data.total_invoices;
        app.notify_counts.total= data.total;
        app.notify.offset=data.offset;
        app.notifys = app.notifys.concat(data.notifys);
        app.is_notify_load = true;

      });
    },
    loadNotify() {
      var app = this;
      app.is_notify_load = false;
      app.notify_counts.comments = 0;
      app.notify_counts.freelance = 0;
      app.notify_counts.projects = 0;
      app.notify_counts.invoices = 0;
      app.notify_counts.total = 0;
      app.notify.offset=0;
      Api.loadNotify(app.notify, function (data) {

        app.notify_counts.comments = data.total_comments;
        app.notify_counts.freelance = data.total_freelance;
        app.notify_counts.projects = data.total_projects;
        app.notify_counts.invoices = data.total_invoices;
        app.notify_counts.total= data.total;
        app.notify.offset=data.offset;
        app.notifys = data.notifys;
        app.is_notify_load = true;

      });
    },
  },
  components: {LoadingBlock}
}
</script>

<style scoped>

</style>